import React from 'react';
import styled from 'styled-components';
import {Route, Switch} from 'react-router-dom';
import Detail from './detail';
import {useCurrentUserQuery, useCurrentClientQuery} from 'api';

export default () => {
  const {
    data: {currentUser = {}},
  } = useCurrentUserQuery({
    fetchPolicy: 'cache-and-network',
  });
  const {
    data: {currentClient} = {},
    error,
    refetch,
  } = useCurrentClientQuery({
    fetchPolicy: 'cache-and-network',
  });

  // 契約情報が取れていない状態で「アクセスできません」と出すと、
  // 取得中や通信失敗の時に契約のある顧客まで締め出してしまう
  if (!currentClient) {
    if (!error) return null;

    return (
      <P>
        データの読み込みに失敗しました。
        <br />
        <RetryButton onClick={() => refetch()}>再読み込み</RetryButton>
      </P>
    );
  }

  if (currentUser.role !== 'admin' && !currentClient.currentLeadContract) {
    return (
      <P>
        お客様のアカウントではこちらのページにアクセスできません。
        <br />
        お手数ですが、担当者までお問い合わせください。
      </P>
    );
  }

  return (
    <Switch>
      <Route path="/pools/:poolId" component={Detail} />
    </Switch>
  );
};


const RetryButton = styled.button`
  margin-top: 16px;
  padding: 4px 16px;
  font-size: 14px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: #ffffff;
  cursor: pointer;
`;

const P = styled.p`
  display: grid;
  place-items: center;
  height: 100vh;
  font-size: 20px;
  text-align: center;
`;
